'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlans = exports.getPlanRouteProps = exports.getPlan = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _reselect = require('reselect');

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _Filters = require('../Filters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeParamsToPropsMap = {
  planName: 'name',
  communityName: 'community.name'
};

var getPlan = function getPlan(_ref, _ref2) {
  var _ref$cloudData = _ref.cloudData;
  _ref$cloudData = _ref$cloudData === undefined ? {} : _ref$cloudData;
  var plans = _ref$cloudData.plans;
  var _ref2$match = _ref2.match,
      match = _ref2$match === undefined ? {} : _ref2$match,
      _id = _ref2._id,
      _ref2$builderId = _ref2.builderId,
      builderId = _ref2$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ref2$builderId;
  var routeMapCommunityName = routeParamsToPropsMap.communityName,
      paramsMap = (0, _objectWithoutProperties3.default)(routeParamsToPropsMap, ['communityName']); // Ignore community

  var _ref3 = match.params || {},
      matchCommunityName = _ref3.communityName,
      params = (0, _objectWithoutProperties3.default)(_ref3, ['communityName']); // Ignore community

  return _fp2.default.getOr([], builderId + '.data', plans).reduce(function (result, item) {
    if (result === undefined && (_id !== undefined && item._id === _id || match && (0, _bdcoreNamedRoutes.paramsMatch)(params, paramsMap, item, true))) {
      return item;
    }

    return result;
  }, undefined);
};

exports.getPlan = getPlan;
var getPlanRouteProps = exports.getPlanRouteProps = function getPlanRouteProps(plan, sources) {
  return (0, _bdcoreNamedRoutes.getPropsFromItem)(plan, routeParamsToPropsMap, true, null, sources);
};

var getPlans = exports.getPlans = (0, _reselect.createSelector)([function (state) {
  return state;
}, function (state, props, builderId) {
  return builderId;
}, function () {
  return _Filters.getFilterValues.apply(undefined, arguments);
}, function (_ref4, _ref5) {
  var _ref4$cloudData = _ref4.cloudData;
  _ref4$cloudData = _ref4$cloudData === undefined ? {} : _ref4$cloudData;
  var plans = _ref4$cloudData.plans;
  var _ref5$builderId = _ref5.builderId,
      builderId = _ref5$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ref5$builderId;
  return _fp2.default.getOr([], builderId + '.data', plans);
}], function (state, builderId, filters, plans) {
  return (0, _Filters.processFilters)(state, 'plans', plans, filters, builderId);
});

exports.default = getPlan;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Plans/selectors.js
// module id = 174
// module chunks = 0